import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";

import DialogTitle from "@mui/material/DialogTitle";
import { Box } from "@mui/material";
import StatisticRow from "./StatisticRow";
import _ from "lodash";

const StatisticsPopup = (props) => {
  const { open, close, task } = props;

  console.log("STATS ", task.stats);
  return (
    <Dialog open={open} onClose={() => close()}>
      <DialogTitle>Statistics</DialogTitle>
      <DialogContent
        sx={{ display: "flex", flexDirection: "row", flex: 1, minWidth: 500 }}
      >
        <Box sx={{ display: "flex", flex: 1, flexDirection: "column" }}>
          <StatisticRow
            field={"Duplicates filtered:"}
            value={_.get(task, "stats.dupefilter/filtered", "N/A")}
          />
          <StatisticRow
            field={"Request max depth:"}
            value={_.get(task, "stats.request_depth_max", "N/A")}
          />
          <StatisticRow
            field={"Offsite domains:"}
            value={_.get(task, "stats.offsite/domains", "N/A")}
          />
          <StatisticRow
            field={"Offsite filtered:"}
            value={_.get(task, "stats.offsite/filtered", "N/A")}
          />
          <StatisticRow
            field={"Focused filtered:"}
            value={_.get(task, "stats.focused_filtered", "N/A")}
          />
          <StatisticRow
            field={"Request count:"}
            value={_.get(task, "stats.downloader/request_count", "N/A")}
          />
          <StatisticRow
            field={"Response count:"}
            value={_.get(task, "stats.downloader/response_count", "N/A")}
          />
          <StatisticRow
            field={"Response bytes:"}
            value={_.get(task, "stats.downloader/response_bytes", "N/A")}
          />
          <StatisticRow
            field={"Response status 200 count:"}
            value={_.get(
              task,
              "stats.downloader/response_status_count/200",
              "N/A"
            )}
          />
          <StatisticRow
            field={"Response status 301 count:"}
            value={_.get(
              task,
              "stats.downloader/response_status_count/301",
              "N/A"
            )}
          />
          <StatisticRow
            field={"Response status 302 count:"}
            value={_.get(
              task,
              "stats.downloader/response_status_count/302",
              "N/A"
            )}
          />
          <StatisticRow
            field={"Response status 303 count:"}
            value={_.get(
              task,
              "stats.downloader/response_status_count/303",
              "N/A"
            )}
          />
          <StatisticRow
            field={"Response status 404 count:"}
            value={_.get(
              task,
              "stats.downloader/response_status_count/404",
              "N/A"
            )}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        {/* <Button onClick={close}>Cancel</Button> */}
        {/* <Button onClick={handleClose}>Subscribe</Button> */}
      </DialogActions>
    </Dialog>
  );
};

export default StatisticsPopup;
